var _ellipse, _ellipse2, _ellipse3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappyFace(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 112,
    viewBox: "0 0 108 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54,
    cy: 56,
    rx: 54,
    ry: 56,
    fill: "#C1FAE2"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.776,
    cy: 46.5161,
    rx: 8.37931,
    ry: 8.58065,
    fill: "#00D681"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.6901,
    cy: 46.5161,
    rx: 8.37931,
    ry: 8.58065,
    fill: "#00D681"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.2244 72.2581C71.2244 72.2581 66.7838 81.2903 53.3274 81.2903C39.8711 81.2903 36.7761 72.2581 36.7761 72.2581",
    stroke: "#00D681",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappyFace);
export default __webpack_public_path__ + "static/assets/happy-face.svg";
export { ForwardRef as ReactComponent };